import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Safe trim for render path: never call .trim() on undefined/null. Use for any value that might come from props/state/API. */
export function safeTrim(s: string | undefined | null): string {
  return (s ?? '').trim();
}

/**
 * Normalize string for search: lowercase, remove accents (á→a, é→e), and ñ→n.
 * Use when comparing query with content so "cafe" matches "café" and "nino" matches "niño".
 */
export function normalizeForSearch(s: string): string {
  if (!s || typeof s !== 'string') return '';
  return s
    .toLowerCase()
    .replace(/ñ/g, 'n')
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');
}

/** Return true if normalized text contains the normalized query (accent/ñ-insensitive). */
export function searchMatch(text: string | undefined | null, query: string | undefined | null): boolean {
  const q = safeTrim(query);
  if (!q) return true;
  const nq = normalizeForSearch(q);
  const nt = normalizeForSearch(text ?? '');
  return nt.includes(nq);
}
